(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["about-us-item"] && !Shopify.designMode) return;
  try {
    ;(function () {
    if (typeof window === 'undefined') return

    function initCountups() {
      var elements = document.querySelectorAll('.js-countup')
      elements.forEach(function (el) {
        var target = parseInt(el.getAttribute('data-target'), 10)
        if (isNaN(target)) return

        var observer = new IntersectionObserver(
          function (entries) {
            entries.forEach(function (entry) {
              if (entry.isIntersecting && !el.dataset.animated) {
                el.dataset.animated = 'true'

                var current = 0
                var increment = target / 120

                var interval = setInterval(function () {
                  current += increment
                  if (current >= target) {
                    current = target
                    clearInterval(interval)
                  }
                  el.textContent = Math.floor(current).toLocaleString()
                }, 1000 / 60)

                observer.unobserve(entry.target)
              }
            })
          },
          { threshold: 0.1 }
        )

        observer.observe(el)
      })
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initCountups)
    } else {
      initCountups()
    }
  })()
  } catch(e) { console.error(e); }
})();

})();
